import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { isAuthenticatedGuard } from './infrastructure/authentication/auth.guard';
import { logoutConfirmationGuard } from './infrastructure/routing/guards/logout-confirmation.guard';
import { errorGuard } from '@app/routes/error/error.guard';
import { navigateToError } from '@app/infrastructure/errors/functions';
import { ErrorCode, ErrorPageRouteState } from '@app/infrastructure/errors/models';
import { ERROR_CODE_DETAILS_MAP } from '@app/routes/error/_constants';
import { LayoutRouteData } from '@app/shared/common/models';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./routes/index/_layout/index.layout').then((m) => m.IndexLayoutComponent),
    loadChildren: () => import('./routes/index/index.routes').then((m) => m.IndexRoutes),
    canActivate: [isAuthenticatedGuard],
    canActivateChild: [isAuthenticatedGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./routes/login/login').then((m) => m.LoginComponent),
    data: { pageTitle: 'Login' } satisfies LayoutRouteData,
  },
  {
    path: 'logout',
    canActivate: [logoutConfirmationGuard],
    loadComponent: () => import('./routes/logout/logout').then((m) => m.LogoutComponent),
    data: { pageTitle: 'Logged Out' } satisfies LayoutRouteData,
  },
  {
    path: 'error',
    loadComponent: () => import('./routes/error/error').then((m) => m.ErrorComponent),
    canActivate: [errorGuard],
    title: () => {
      const state = inject(Router).currentNavigation()?.extras.state as
        | ErrorPageRouteState
        | undefined;
      return (state && ERROR_CODE_DETAILS_MAP[state.errorCode]?.error?.code) || 'Error';
    },
  },
  {
    path: '**',
    canActivate: [
      () => {
        const router = inject(Router);
        navigateToError(ErrorCode.NotFound404, router);
        return false;
      },
    ],
    children: [],
  },
];
